<template>
  <div class="hello">
    <div class="headerImage" :style="{background:'url('+ imagelr +')',backgroundRepeat:'no-repeat',backgroundSize:'100% 100%'}">
      <div class="header_title">
        <p>“ {{title}} ”</p>
        <span>{{retitle}} </span>
      </div>
      <div class="baomingParent">
        <div class="baoming" @click="baoming">
          <img v-if="lang == 'cn'" src="../../assets/image/sign.png" alt="">
          <img v-else src="../../assets/image/signE.png" alt="">
        </div>
        <div class="baoming" @click="ruwei">
          <img v-if="lang == 'cn'" src="../../assets/image/ruwei.png" alt="">
          <img v-else src="../../assets/image/ruweiEn.png" alt="">
        </div>
      </div>

      <div class="introduction">
        <span>{{info}}</span>
      </div>
      <div class="foote">
        <div class="content">
          <div class="sign" v-html="jianjielist"></div>
        </div>
        <div style="height: 50px;"></div>
      </div>
    </div>



    <!-- 报名投票 -->
    <div class="addMask" v-if="addMaShow">

      <div class="addcontent">
        <div class="closeEa" @click="closeEa()">
          <img src="../../assets/image/close.png" alt="">
        </div>
        <div class="navTop">
          <span>
            {{$t('language.exhibitors')}}
          </span>
        </div>
        <div class="contentLabel">
          <div class="tabLab">
            <div class="labelName">
              {{$t('language.works')}}
            </div>
            <div class="select">
              <el-select v-model="value" :placeholder="$t('language.place')" @change="changTab($event)">
                <el-option v-for="item in options" :key="item.id" :label="item.display_name" :value="item.photographer">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="tabLab">
            <div class="labelName">
              {{$t('language.PhotographerName')}}
            </div>
            <div class="select">
              <el-select v-model="values" :placeholder="$t('language.place')" @change="changeS()">
                <el-option v-for="item in photographer" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="lines"></div>
          <div class="tabLab">
            <div class="labelName">
              {{$t('language.workphoto')}}
            </div>
            <div class="works">
              <div class="addlist" v-for="(item,index) in uploadList" :key="index" @click="uploadEvent(index)">
                <img v-if="item.file_type == 'image'" :src="item.display_path" alt="">
                 <video v-else :src="item.display_path" ></video>
              </div>
            </div>
          </div>
          <div class="lines"></div>
          <div class="tabLab">
            <div class="labelName" >
              {{$t('language.uploadWork')}}
            </div>
            <div class="uploade">
              <div class="uploadList" v-for="(item,index) in arr" :key="index">
                <div class="headerTop">
                  <!-- <div class="headimg"></div> -->
                  <div style="height: 30px;"></div>
                  <div class="userName">
                    <span>{{item.name}}</span>
                  </div>
                </div>
                <div class="headRight">
                  <div class="uploa" v-if="item.image" v-for="(ite,ind) in item.image" :key="ind">
                    <img v-if="ite.file_type == 'image'" :src="ite.display_path" alt="">
                     <video v-else :src="ite.display_path" controls="controls"></video>
                    <div class="close" @click="closeEvent(index,ind)">
                      <img src="../../assets/image/close.png" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="submit" @click="submitBtn">
            <span>{{$t('language.sign')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        addMaShow: false,
        uploadList: [],
        uploadPlas: [],
        options: [],
        photographer: [],
        arr: [],
        value: '',
        values: '',
        title: '',
        imagelr:'',
        retitle: '',
        imageUrl: require('../../assets/image/vote.png'),
        os: [],
        jianjielist: '',
        info: '',
        lang:'cn'
      }
    },
    created() {
      if(localStorage.getItem('languageSet') == 'zh'){
        this.lang = 'en';
      }else{
        this.lang = 'cn'
      }
      var data = {
        id: this.$route.query.id
      }
      this.$fetch('/vote/actDetail', data).then(res => {
        console.log(res)
        this.title = res.data.title;
        this.retitle = res.data.retitle;
        this.jianjielist = res.data.apply_explain;
        this.imagelr = res.data.bgimg_pc.display_path;
        this.info = res.data.info;
      })

      // 展览信息
      this.$fetch('/vote/applyInfo', data).then(res => {
        console.log(res);
        res.data.forEach(item=>{
          if(item.display_name == ''){

          }else{
            this.options.push(item)
          }
        })

      })
    },
    methods: {
      closeEa(){
        this.values = '';
        this.uploadList = [];
        this.addMaShow = false;
      },
      uploadEvent(index) {
        for(var i = 0; i < this.photographer.length; i++){
          if(this.photographer[i].id == this.values){
             this.arr.push(this.photographer[i]);
          }
        }
        var result = [];
        var obj = {};
        for (var i = 0; i < this.arr.length; i++) {
          if (!obj[this.arr[i].id]) {
            result.push(this.arr[i]);
            obj[this.arr[i].id] = true;
          }
        }
        this.arr = result;
        for (var i = 0; i < this.arr.length; i++) {
          if (!this.arr[i].image) {
            this.arr[i].image = [];
          }
          if (this.values == this.arr[i].id) {
            if (this.arr[i].image.indexOf(this.uploadList[index]) == -1) {
              this.arr[i].image.push(this.uploadList[index])
            }
           this.arr[i].image = this.unique(this.arr[i].image)
          }
        }
      },
      unique(arr) {
        const res = new Map();
        return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
      },
      closeEvent(index, ind) {

        this.arr[index].image.splice(ind, 1)
        this.arr = Object.assign([], this.arr)
        if (this.arr[index].image.length == 0) {
          this.arr.splice(index, 1);
        }
      },
      changTab(e) {
        this.uploadList = []
        this.values = []
        console.log(this.value);
        this.photographer = this.value;


      },
      changeS(e) {
        console.log(this.values);
        var data = {
          photographer_id: this.values
        }
        this.$fetch('/vote/applyWork', data).then(res => {
          this.uploadList = res.data;
        })
      },
      baoming(){
        if(!localStorage.getItem('access_token')){
          this.$message.error(this.$t('language.onLogin'));
          this.$router.push('/');
        }
        this.addMaShow = true;
      },
      submitBtn(){
        var obj = {}
        for(var i = 0; i < this.arr.length;i++){
          obj[this.arr[i].id] = [];
          for(var j = 0; j < this.arr[i].image.length;j++){
            obj[this.arr[i].id].push(this.arr[i].image[j].id)
          }
        }
        var data = {
          id:this.$route.query.id,
          data:obj
        }
        this.$post('/vote/itemAdd',data).then(res=>{
          if(res.code == 200){
            this.$message.success(res.message)
            this.addMaShow = false;
            this.uploadList = [];
            this.values = '';
             this.arr = [];
          }else{
            this.addMaShow = true;
          }
        })
      },
      ruwei(){
        var that = this;
        this.$router.push({
          path:'/hand',
          query:{
            id:that.$route.query.id
          }
        })
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../../assets/css/detail/soliciting.css");
</style>



// WEBPACK FOOTER //
// src/pages/detail/soliciting.vue